import { render, staticRenderFns } from "./StudentMealReport.vue?vue&type=template&id=b479d06c&scoped=true"
import script from "./StudentMealReport.vue?vue&type=script&lang=js"
export * from "./StudentMealReport.vue?vue&type=script&lang=js"
import style0 from "./StudentMealReport.vue?vue&type=style&index=0&id=b479d06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b479d06c",
  null
  
)

export default component.exports